/**
 * Sticky Sidebar for Related Posts
 * Makes the related posts sidebar sticky after scrolling past the hero image
 */

document.addEventListener('DOMContentLoaded', function() {
    const relatedPosts = document.querySelector('.related-posts');
    const heroBanner = document.querySelector('.single-hero-banner');
    
    // Only proceed if both elements exist and we're on desktop
    if (!relatedPosts || !heroBanner) return;
    
    // Only apply on desktop (768px and above)
    if (window.innerWidth < 768) return;
    
    // Get the header height for offset
    const header = document.querySelector('.navbar');
    const headerHeight = header ? header.offsetHeight : 0;
    
    // Calculate when to start sticking (after hero banner)
    const heroBottom = heroBanner.offsetTop + heroBanner.offsetHeight;
    
    // Get the sidebar column
    const sidebarColumn = relatedPosts.closest('.col-md-3');
    const mainColumn = document.querySelector('.col-md-9');
    
    if (!sidebarColumn || !mainColumn) return;
    
    // Store original styles
    const originalTop = window.getComputedStyle(relatedPosts).top;
    const originalPosition = window.getComputedStyle(relatedPosts).position;
    
    function handleScroll() {
        // Skip on mobile
        if (window.innerWidth < 768) {
            relatedPosts.style.position = originalPosition;
            relatedPosts.style.top = originalTop;
            return;
        }
        
        const scrollY = window.scrollY;
        const mainBottom = mainColumn.offsetTop + mainColumn.offsetHeight;
        const sidebarHeight = relatedPosts.offsetHeight;
        
        // Calculate stop point (when sidebar would go past main content)
        const stopPoint = mainBottom - sidebarHeight - headerHeight - 20; // 20px padding
        
        if (scrollY > heroBottom - headerHeight) {
            if (scrollY >= stopPoint) {
                // Stop at bottom of main content
                relatedPosts.style.position = 'absolute';
                relatedPosts.style.top = (stopPoint - sidebarColumn.offsetTop) + 'px';
            } else {
                // Make it sticky
                relatedPosts.style.position = 'fixed';
                relatedPosts.style.top = (headerHeight + 20) + 'px'; // 20px padding from header
                relatedPosts.style.width = sidebarColumn.offsetWidth + 'px'; // Maintain width
            }
        } else {
            // Reset to original position
            relatedPosts.style.position = originalPosition;
            relatedPosts.style.top = originalTop;
            relatedPosts.style.width = '';
        }
    }
    
    // Handle scroll events
    let ticking = false;
    function requestTick() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }
    
    // Add scroll listener
    window.addEventListener('scroll', requestTick);
    
    // Handle resize events
    window.addEventListener('resize', function() {
        handleScroll();
    });
    
    // Initial check
    handleScroll();
});